import {getLocalStorageItem, setLocalStorageItem} from '@gaia/utils/localStorage';
import {useEffect, useMemo, useState} from 'react';

interface UseOverlaysStateOptions {
    showAreasProp: boolean | undefined;
    showTracksProp: boolean | undefined;
    showRoutesProp: boolean | undefined;
    showWaypointsProp: boolean | undefined;
    showKnownRoutesProp: boolean | undefined;
}

export default function useOverlaysState({
    showAreasProp,
    showTracksProp,
    showRoutesProp,
    showWaypointsProp,
    showKnownRoutesProp,
}: UseOverlaysStateOptions): [OverlaysState, SetState<OverlaysState>] {
    const [state, setState] = useState<OverlaysState>(() => ({
        showAreas: true,
        showTracks: true,
        showRoutes: true,
        showPublicTracks: false,
        showWaypoints: true,
        showWaypointLabels: false,
        showKnownRoutes: true,
        ...getLocalStorageItem<Partial<OverlaysState>>('overlays', {}),
    }));

    useEffect(() => {
        setLocalStorageItem('overlays', state);
    }, [state]);

    const overlays = useMemo(
        () => ({
            ...state,
            ...(showAreasProp !== undefined && {showAreas: showAreasProp}),
            ...(showTracksProp !== undefined && {showTracks: showTracksProp}),
            ...(showRoutesProp !== undefined && {showRoutes: showRoutesProp}),
            ...(showWaypointsProp !== undefined && {
                showWaypoints: showWaypointsProp,
            }),
            ...(showKnownRoutesProp !== undefined && {
                showKnownRoutes: showKnownRoutesProp,
            }),
        }),
        [
            state,
            showAreasProp,
            showTracksProp,
            showRoutesProp,
            showWaypointsProp,
            showKnownRoutesProp,
        ]
    );

    return [overlays, setState];
}
